import { Select, Table } from "antd";
import { toast } from "react-toastify";
import { changeAdminPermission } from "../../../firebase/utils";
import permissionsData from "../../../Constant/PermissionsContant";

const RoleTable = ({ adminData, setAdmins, loading }) => {

  const handlePermissionChange = async (userEmail, permission, value, userPermissions) => {
    if (!userEmail) return;

    const updatedPermissions = {
      ...userPermissions,
      [permission]: value,
    };

    try {
      await changeAdminPermission(userEmail, updatedPermissions);
      setAdmins((prevAdmins) =>
        prevAdmins.map((admin) =>
          admin.email === userEmail
            ? { ...admin, permissions: updatedPermissions }
            : admin
        )
      );
      toast.success("Permissions updated successfully!");
    } catch (error) {
      toast.error("Failed to update permissions");
    }
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      fixed: "left",
    },
    ...Object.keys(permissionsData).map((permission) => ({
      title: permission.charAt(0).toUpperCase() + permission.slice(1),
      dataIndex: ["permissions", permission],
      key: permission,
      render: (_, record) => (
        <Select
          style={{ minWidth: "130px" }}
          value={record.permissions?.[permission] || "Not Allow"}
          onChange={(value) => handlePermissionChange(record.email, permission, value, record.permissions)}
        >
          {permissionsData[permission].map((option) => (
            <Select.Option key={option} value={option}>
              {option}
            </Select.Option>
          ))}
        </Select>
      ),
    })),
  ];

  return (
    <Table
      loading={loading}
      columns={columns}
      dataSource={adminData}
      rowKey="id"
      bordered
      pagination={false}
      scroll={{ x: "auto" }}
    />
  );
};

export default RoleTable;
